import React, { useState, useEffect } from 'react'
import { colorMap, getLinkFromRef, getLink, getLinkUrl } from '../../utility'

import { Link2 } from '../link/link.jsx'
import { CollectiveInvestmentTrustsTable } from './CollectiveInvestmentTrustsTable.jsx'
import { MutualFundsTable } from './MutualFundsTable.jsx'

export const ResourceArticle = ({ page, component }) => {
  const [parameters, setParameters] = useState({
    layout: null,
  })
  const [styles, setStyles] = useState({
    backgroundColor: null,
    textColor: null,
    secondaryColor: null,
    contentColor: null,
    buttonClass: null,
    line: null,
    alignment: null,
    dataTags: null,
  })
  const [blurb, setBlurb] = useState({
    id: null,
    document: null,
    title: null,
    subtitle: null,
    html: null,
    link: null,
  })

  useEffect(() => {
    const _parameters = component.getParameters()
    const _models = component.getModels()
    const _document = _models?.document && page.getContent(_models?.document)
    setParameters({
      layout: _parameters?.layout,
      scope: _parameters?.scope,
    })

    setStyles({
      ...colorMap[_parameters.backgroundColor || 'None'],
    })

    if (_document) {
      const data = _document?.getData() || {}
      setBlurb({
        id: data?.title?.replaceAll(' ', '').replaceAll("'", ''),
        document: _document,
        title: data?.title,
        subtitle: data?.subtitle,
        html:
          data?.html && typeof data?.html === 'object'
            ? data.html.value
            : data.html || data.content,
        link: getLink(getLinkFromRef(data?.linkCompound, page), null),
        linkList: data?.linkList?.links
          .filter((l) => l.link && l.link.length > 0)
          .map((l) => getLink(getLinkFromRef(l, page), null)),
      })
    }
  }, [])

  const renderView = (layout) => {
    switch (layout) {
      case 'MutualFundsTable':
        return (
          <TableView {...{ styles, blurb }}>
            <MutualFundsTable {...{ parameters }} />
          </TableView>
        )
      case 'CollectiveInvestmentTrustsTable':
        return (
          <TableView {...{ styles, blurb }}>
            <CollectiveInvestmentTrustsTable {...{ parameters }} />
          </TableView>
        )
      case 'List':
        return <ListView {...{ styles, blurb }} />
      case 'Banner':
      default:
        return <BannerView {...{ styles, blurb }} />
    }
  }

  const layoutPaddingClass = {
    Banner: 'u-paddingVert5gu',
    List: 'u-paddingVert12gu',
    CollectiveInvestmentTrustsTable: 'u-paddingVert12gu',
    MutualFundsTable: 'u-paddingVert12gu',
  }

  return (
    <div
      id={blurb.id}
      className={`${
        layoutPaddingClass[parameters.layout] ?? 'u-paddingVert2gu'
      } ${styles.backgroundColor}`}
    >
      <div className="u-sizeConstrained">{renderView(parameters.layout)}</div>
    </div>
  )
}

const TableView = ({ blurb, styles, children }) => (
  <>
    {blurb?.title && (
      <h2 className={`u-textDefault u-paddingBottom4gu ${styles.textColor}`}>
        {blurb?.title}
      </h2>
    )}
    {children}
  </>
)

const ListView = ({ blurb, styles }) => (
  <>
    {blurb?.title && (
      <h2 className={`u-textDefault u-paddingBottom4gu ${styles.textColor}`}>
        {blurb?.title}
      </h2>
    )}
    <div className="u-flex u-flexWrap">
      {blurb?.linkList?.map((i, idx) => (
        <div
          key={idx}
          className={`u-flex u-flexCol u-sm-sizeFull u-lg-size1of2`}
        >
          <div
            className={`u-padding3gu u-borderBottom u-borderColorNeutralLight u-sm-marginHoriz0 ${
              idx % 2 == 0 ? 'u-marginRight4gu' : 'u-marginLeft4gu'
            } ${idx < 2 ? 'u-borderTop' : ''} ${
              idx === 1 ? 'u-sm-borderTop0' : ''
            }`}
          >
            <Link2
              url={getLinkUrl(i)}
              text={i?.text}
              textClasses="u-textSecondary u-textSizeMsr"
            />
          </div>
        </div>
      ))}
    </div>
  </>
)

const BannerView = ({ blurb, styles }) => (
  <div className="u-flex u-flexRow u-sm-flexCol u-flexAlignItemsCenter u-sm-flexAlignItemsStart">
    <div className="u-flexGrow1 u-paddingVert2gu">
      {blurb?.title && (
        <h3 className={`u-textDefault u-paddingBottom1gu ${styles.textColor}`}>
          {blurb?.title}
        </h3>
      )}
      {blurb?.subtitle && (
        <p className={`Type-3 ${styles.textColor} u-textDefault u-textNormal`}>
          {blurb?.subtitle}
        </p>
      )}
    </div>
    {blurb.link?.url && blurb.link?.text && (
      <div className="u-marginLeft5gu u-sm-marginLeft0 u-sm-marginTop3gu u-sm-marginBottom3gu">
        <Link2
          url={getLinkUrl(blurb.link)}
          text={blurb.link.text}
          icon={blurb.link.icon}
          iconColor={styles.secondaryColor}
          className={`Button Button--secondary ${styles.buttonClass}`}
        />
      </div>
    )}
  </div>
)
